import React, { useEffect, useState } from "react";
import "./paymentBox.scss";
import PriceItem from "../../atoms/PriceItem/PriceItem";
import BtnStandardIconText from "../../../ds/BtnStandardIconText/BtnStandardIconText";
import CardDetails from "../CardDetails/CardDetails";
import {
  useFileUpload,
  useOrders,
  useUnpaidOrders,
} from "../../../hooks/orders";
import { usePaymentCardsQuery } from "../../../hooks/cards";
import axios from "axios";
import { useSnackbar } from "notistack";
import useOrderPrices from "../../../hooks/prices";
import Cookies from "js-cookie";
import PaymentLoader from "../../../loaders/PaymentLoader";
import { useContent, useLanguages } from "../../../hooks/content";
import { Returntext } from "../../../pages/Landings/common/returnText";
import { useNavigate } from "react-router-dom";
import { ReactComponent as WarnRecIcon } from "../../../icons/warn-rec.svg";
import PriceItem2 from "../../atoms/PriceItem/PriceItem2";
import PaymentTypeSwitcher from "../PaymentTypeSwitcher/PaymentTypeSwitcher";
import { useDispatch, useSelector } from "react-redux";
import { setB2BDrawerStep1, setPaymentDrawer } from "../../../redux/actions";

const PaymentBoxB2B = ({
  selectedOrders,
  nextClick,
  activeOrder,
  address,
  setActiveOrder,
  cancelClick,
}) => {
  const { lang } = useLanguages();
  const { contentManagementData } = useContent();

  const [loading, setLoading] = useState(false);

  const userinvoice = JSON.parse(localStorage.getItem("user"));

  const access_token = Cookies.get("access_token");

  const [invoice, setInvoice] = useState(null);

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/transactions/invoice/${activeOrder?.payments[0]?.id}?accessToken=${access_token}`
        );
        setInvoice(response.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchInvoice();
  }, [activeOrder, access_token]);

  return (
    <div className="payment-box">
      {loading && <PaymentLoader />}
      <div className="p-items">
        {invoice && (
          <PriceItem2
            left={`${Returntext(
              contentManagementData,
              "air_freight_fee",
              lang
            )}`}
            right={
              <div className="rc">
                <span className="gr">{`${invoice?.gzavniliPrice}₾`}</span>
              </div>
            }
          />
        )}
        <PriceItem
          left={Returntext(contentManagementData, "PBTD", lang)}
          right={`${invoice ? invoice?.transportation : "0"}.00₾`}
        />
        {invoice && invoice?.customFeeTotal > 0 && (
          <PriceItem
            left={Returntext(contentManagementData, "PBTDS", lang)}
            right={`${invoice ? invoice?.customFeeTotal : "0"}.00₾`}
          />
        )}
        {invoice && invoice?.serviceFee > 0 && (
          <PriceItem
            left={Returntext(contentManagementData, "PBTDP", lang)}
            right={`${invoice ? invoice?.serviceFee : "0"}.00₾`}
          />
        )}
      </div>

      <div className="line"></div>

      {/* {invoice && && (
        <PriceItem
          left={Returntext(contentManagementData, "discount", lang)}
          right={`${invoice?.discountAmount}₾`}
        />
      )} */}

      <div className="total">
        <div className="left">
          {Returntext(contentManagementData, "PBST", lang)}
        </div>
        <div className="right">
          {invoice ? invoice?.total?.toFixed(2) : "0.00"}₾
        </div>
      </div>
    </div>
  );
};

export default PaymentBoxB2B;
